// extracted by mini-css-extract-plugin
module.exports = {"container":"Clients_container__3pqRI","aside":"Clients_aside__1LvAb","title":"Clients_title__s2C5g","p":"Clients_p__2jLrQ"};